import { combineReducers } from 'redux'
import ActionsAllReducer from './actions.all.reducer'
import ActionsItemReducer from './actions.item.reducer'

const ActionsReducer = combineReducers({
  all: ActionsAllReducer,
  item: ActionsItemReducer,
})

export default ActionsReducer